import { environment } from '../../environments/environment';

export function sportsBetting(sbToken, key,url,merchantType) {
    if (url) {
        var script = document.createElement('script');
        script.src = `${url}`;
        script.onload = function () {
            var token = sbToken;
            var lang = "en-GB";
            if(key == 'Y') {
                const integrationValue = merchantType == 'GY' ? environment.altenarIntegrationGY : environment.altenarIntegrationJM;
                window.altenarWSDK.init({ integration: integrationValue, culture: 'en-GB', token: token });

            // Add sportsbook
            var ASB = window.altenarWSDK.addSportsBook({
                props: {
                    page: 'overview',
                    routerType: 'memory',
                    onRouteChange: onRouteCallback,
                    onBetPlacement: betPlaceCallback
                },
                container: document.getElementById('sb2Container'),
            });

            function onRouteCallback(altenarProps) {
                window.scroll(0, 0);
            };

            function betPlaceCallback(bets) {
                    var event = new CustomEvent('sports-callback', { detail: bets });
                    window.dispatchEvent(event);
                }

            window.addEventListener("Destroy-Prelive", (e) => {
                ASB.remove();
            });
        } else {
            var initParams = { walletcode:merchantType=='GY'?environment.walletCodeGY:environment.walletCodeJM, token: token, lang: lang, page: 'prelive', Currency: 'JMD', isHashMode: false };
            var ASb = new AltenarSportsbook('#sb2Container', initParams, { triggerCallback: true });
            ASb.getParams();
            ASb.setParam('placebetcallback', function (e) {
                if (e.length > 0) {
                   let betIDarray = [];
                   for (let i = 0; i< e.length;i++) {
                    betIDarray.push(e[i].betId)
                  }
                    var event = new CustomEvent('callBack', { detail: betIDarray  });
                    window.dispatchEvent(event);
                }
            });
            window.addEventListener("Destroy-Prelive", function (e) {
                ASb.destroy();
            });
        }
        }

        document.documentElement.appendChild(script);
    }
}

